import React, { Component } from 'react';
import { connect } from 'react-redux';
import { navigate } from '../modules/high_level_actions';

class NonClubLandingPage extends Component {
  render() {
  	let { member_services_email, member_services_phone, tla, full_name } = this.props;
  	let paymentEvent = {
  		currentTarget: { pathname: '/payment' },
  		preventDefault: () => {}
  	};

    return (
      <div className="content-max-width landing-page">
       <div className="inner-wrapper">

       	<a href="/" onClick={(evt) => this.props.dispatch( navigate(evt))} className="logo">
			{ ['skl','jpl','cbc'].includes(tla.toLowerCase()) ? <img src={'/images/' + tla.toLowerCase() + '/logo.png'} /> : <img src={'/images/' + tla.toLowerCase() + '/logo.svg'} style={{filter:"invert(1)"}} /> }
       	</a>

		{
			['crf','spt','tgc'].includes(tla.toLowerCase()) && <div>
				<h3>
					Find us at the <a href="https://www.literaryguild.com">Literary Guild</a> using your current login information.
					<br></br>
					There you will find the same great titles and savings you have come to expect!
				</h3>
				<a href="https://www.literaryguild.com">
					<img src={'/images/lga/logo.svg'} style={{filter:"invert(1)"}}/>
				</a>
			</div>
		}

		{
			['lsc','mil'].includes(tla.toLowerCase()) && <div>
				<h3>
					Find us at the <a href="https://www.historybookclub.com">History Book Club</a> using your current login information.
					<br></br>
					There you will find the same great titles and savings you have come to expect!
				</h3>
				<a href="https://www.historybookclub.com">
					<img src={'/images/hbc/logo.svg'} style={{filter:"invert(1)"}}/>
				</a>
			</div>
		}

       	<h3>
       		If you would like to make a payment to your {full_name} account balance, please click here:
       	</h3>

       	<button className="btn-primary" onClick={() => this.props.dispatch( navigate(paymentEvent))}>
       		Make A Payment
       	</button>

       	<h3>
       		For all other questions, please contact us by emailing <a className="highlight-color"
          href={"mailto:"+member_services_email}>{member_services_email}</a>
       		<br /> or calling {member_services_phone} M-F 8am to 6pm EST.
       	</h3>

       </div>
      </div>
    );
  }
};

function mapStateToProps(state){
    return {
    	'tla': state.store.tla,
      	'full_name': state.store.full_name,
    	'member_services_email': state.store.member_services_email,
    	'member_services_phone' : state.store.member_services_phone
    };
}

export default connect(mapStateToProps)(NonClubLandingPage);


// WEBPACK FOOTER //
// ./src/components/NonClubLandingPage.jsx